<template lang="pug">
  .renewal-container(v-if="show")
    .renewal-block
      .user-info
        .left-block
          .user-name 哈啰超级会员
          .member-limit {{ expirationDate | time('YYYY.MM.DD') }}到期，剩余{{remainDays}}天
        .right-block
          .close-btn(@click="closeModal")
            img(src="https://m.hellobike.com/resource/helloyun/08345/n2qZfVGMcQ.png?x-oss-process=image/quality,q_80")
      .open-choose
        TransTab.trans-tab(@chooseMember="chooseMember" :markedPrice="markedPrice",
        :price="price",:signInfoDTO="signInfoDTO||{}" openType="alreadyOpen" )
      .renewal-rule-des(v-if="allMonth")
        span.des-black 次月起 ¥{{signInfoDTO.secondSignPrice||'-'}}/月续费，可关闭
      .renewal-rule-des(v-else)
        span.des-black
      .preferential-benefits
        .benefits-title 续费会员优惠权益继续享
        .benefits-des 将在{{remainDays||'0'}}天后(当前会员过期后)，发放本次续费的会员权益
        .open-popup
          .open-btn(@click='open')
            span.symbol ¥
            span.text {{openPrice}} 立即开通
            lottie.lottie(url='https://m.hellobike.com/resource/helloyun/07177/miBR5C3_ZS.json', ref='anime')
            .toast.part.flex-mid(v-if="couponEndTime&&d<1&&!allMonth")
              img(src="https://m.hellobike.com/resource/helloyun/08345/74ESsSzstH.png")
              span 已优惠{{(markedPrice-price).toFixed(2) ||"-"}}元
              span ,{{h}}:{{m}}:{{s}}后失效
            .toast-short.part.flex-mid(v-if="((!couponEndTime)||d>=1)&&!allMonth")
              img(src="https://m.hellobike.com/resource/helloyun/08345/74ESsSzstH.png")
              span 已优惠{{(markedPrice-price).toFixed(2) ||"-"}}元
            .toast-short.part.flex-mid(v-if="allMonth")
              .bestChoose 限时优惠
          .renewal-rules
            span.normal 购买即同意
            span.canClick(@click="goMember") 《哈啰会员服务协议》
            span.normal 与
            span.canClick(@click="goRenewal") 《自动续费协议》
    .shadow(@click="closeModal")
</template>
<script>
import Lottie from '@/components/lottie';
import { commonGoLink, getTokenAndLocation } from '@/utils';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { env } from '@hb/hbridge';
import { getBenifitsInReopen } from '@/api/vip';
import { getSystemCode } from '@/utils/systemCode';
import { getSource } from '../../../../utils';
import TransTab from './transTab.vue';


export default {
  components: {
    Lottie,
    TransTab,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    // showPopUpWindowType: {
    //   type: Number,
    //   default: 0,
    // },
    remainDays: {
      type: Number,
      required: true,
    },
    expirationDate: {
      type: Number,
      required: true,
    },
    commonBonus: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loadingPay: false,
      env,
      d: undefined,
      h: '',
      m: '',
      s: '',
      timer: null,
      timeout: null,
      simpleGroupInfos: [],
      markedPrice: 0,
      price: 0,
      signInfoDTO: {},
      allMonth: true,
      couponEndTime: null,
      goodsGuid: '',
    };
  },
  computed: {
    openPrice() {
      if (this.allMonth) {
        return this.signInfoDTO.firstSignPrice;
      }
      return this.price || '-';
    },
  },
  destroyed() {
    this.timer = null;
    this.timeout = null;
  },
  created() {
    UBT.moduleExpose({
      pageId: 'platform_savemoneycard_page',
      categoryId: 'platform',
      moduleId: 'platform_opencard_button',
      contentId: 'platform_opencard_button',
      exposureTimes: 1,
      businessInfo: {
        adsource: getSource(),
      },
    });
  },
  async mounted() {
    const { cityCode, token } = await getTokenAndLocation();
    getBenifitsInReopen({ token, systemCode: getSystemCode(), cityCode }).then((res) => {
      if (res && res.data) {
        Object.assign(this, res.data);
        // this.simpleGroupInfos = res.data.simpleGroupInfos;
        // this.markedPrice = res.data.markedPrice;
        // this.price = res.data.price;
        // this.signInfoDTO = res.data.signInfoDTO;
        // this.couponEndTime = res.data.couponEndTime;
        // this.couponEndTime = Date.now() + 10000;
        this.openTime();
      }
    });
    if (this.$refs.anime) {
      this.$nextTick(() => {
        this.$refs.anime.lottie.setSpeed(1.3);
      });
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
      this.$emit('update:show', false);
    },
    // 连续包月规则链接
    goRenewal() {
      commonGoLink('https://m.hellobike.com/mf/spa/u_hywaxn/latest/MA2209193493443248207695231.html?activityCode=MA2209193493443248207695231', { isRuleLink: true });
    },
    // 付费会员规则链接
    goMember() {
      commonGoLink('https://m.hellobike.com/mf/spa/u_yewmjx/latest/MA2209283520078470713971794.html?activityCode=MA2209283520078470713971794', { isRuleLink: true });
    },
    chooseMember(type) {
      this.allMonth = type;
    },
    openTime() {
      const now = new Date().getTime();
      // time改为couponEndTime
      this.timeout = this.couponEndTime - now;
      this.timer = setInterval(() => {
        if (this.timeout <= 0) {
          clearInterval(this.timer);
          return;
        }
        this.showTime(this.timeout);
        this.timeout -= 1000;
      }, 1000);
    },
    showTime(timeout) {
      // 后台给我的是10位 精确到秒的  所有下面我就除以了1000，不要小数点后面的
      // eslint-disable-next-line no-console
      if (timeout && timeout > 0) {
        const t = timeout;
        // eslint-disable-next-line no-console
        // 如果后台给的是毫秒 上面不用除以1000  下面的计算时间也都要除以1000 这里我去掉1000了
        this.d = Math.floor(t / 1000 / 60 / 60 / 24); // 天 var d=Math.floor(t/1000/60/60/24)
        // eslint-disable-next-line no-mixed-operators
        const h = Math.floor((t / 1000 / 60 / 60) % 24);
        // 时 var h=Math.floor(t/1000/60/60%24)
        // eslint-disable-next-line no-mixed-operators
        const m = Math.floor((t / 1000 / 60) % 60); // 分 var m=Math.floor(t/1000/60%60)
        // eslint-disable-next-line no-mixed-operators
        const s = Math.floor((t / 1000) % 60); // 秒 var s=Math.floor(t/1000%60)
        // if (parseInt(d, 10) < 10) {
        //   this.d = `0${d}`;
        // } else {
        //   this.d = `${d}`;
        // }
        if (parseInt(h, 10) < 10) {
          this.h = `0${h}`;
        } else {
          this.h = `${h}`;
        }
        if (parseInt(m, 10) < 10) {
          this.m = `0${m}`;
        } else {
          this.m = `${m}`;
        }
        if (parseInt(s, 10) < 10) {
          this.s = `0${s}`;
        } else {
          this.s = `${s}`;
        }
      }
    },
    open() {
      UBT.clickButton({
        pageId: 'platform_savemoneycard_page',
        buttonName: 'platform_opencard_button',
        categoryId: 'platform',
        businessInfo: {
          adsource: getSource(),
        },
      });
      this.$emit('open', null, this.allMonth ? 30 : 20, this.openPrice, this.goodsGuid);
    },
  },
};
</script>
<style lang="less" scoped>
.renewal-container {
  font-family: PingFangSC-Medium, PingFang SC, sans-serif;

  .renewal-block {
    position: fixed;
    padding: 0.14rem 0.2rem 0;
    bottom: 0;
    z-index: 222;
    height: 3rem;
    width: 100%;
    background-image: url(https://m.hellobike.com/resource/helloyun/08345/27cLuzlpdI.png?x-oss-process=image/quality,q_80);
    background-size: cover;
    background-repeat: no-repeat;
    border-radius: 12px 12px 2px 2px;

    .user-info {
      display: flex;
      justify-content: space-between;

      .left-block {
        display: flex;

        .user-name {
          font-size: 0.16rem;
          font-weight: 650;
          color: #6f2500;
        }

        .member-limit {
          padding-top: 0.04rem;
          margin-left: 0.08rem;
          font-size: 0.12rem;
          font-weight: 400;
          color: #8c4c24;
          opacity: 0.67;
        }
      }

      .right-block {
        .close-btn {
          img {
            width: 0.12rem;
            height: 0.12rem;
          }
        }
      }
    }

    .open-choose {
      margin-top: 0.12rem;
      height: 0.6rem;
      width: 100%;
    }

    .renewal-rule-des {
      margin-top: 0.08rem;
      font-size: 0.12rem;
      font-weight: 400;
      height: 0.17rem;
      width: 100%;

      .des-black {
        color: #242729;
      }
    }

    .preferential-benefits {
      margin-top: 0.18rem;

      .benefits-title {
        font-size: 0.16rem;
        font-weight: 650;
        color: #6f2500;
      }

      .benefits-des {
        margin-top: 0.02rem;
        font-size: 0.12rem;
        font-weight: 400;
        color: #8c4c24;
        opacity: 0.7;
      }

      .benefits-types {
        margin-top: 0.16rem;
        display: flex;
        overflow-x: auto;
        overflow-y: hidden;
        white-space: nowrap;
        padding: 0 0.07rem;
        margin-left: -0.38rem;

        &::-webkit-scrollbar {
          display: none;
          width: 0;
          height: 0;
          color: transparent;
        }

        .benefits-type {
          display: inline-flex;
          flex-direction: column;
          align-items: center;
          margin-left: 0.3rem;
          text-align: center;
          white-space: nowrap;
          height: 0.9rem;

          .coupon-icon {
            width: 0.46rem;
            height: 0.46rem;
          }

          .coupon-title {
            margin-top: -0.01rem;
            max-width: 0.84rem;
            font-size: 0.12rem;
            font-family: PingFangSC-Semibold, PingFang SC, sans-serif;
            font-weight: 600;
            color: #a54700;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }

          .coupon-des {
            margin-top: -0.01rem;
            font-weight: 400;
            color: #a54700;
            font-size: 0.12rem;
            transform: scale(0.97);
            opacity: 0.65;
          }
        }
      }

      .open-popup {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 1.23rem;
        z-index: 225;
        box-shadow: 0 -0.02rem 0.08rem 0 rgba(36, 39, 41, 0.08);
        border-radius: 0.12rem 0.12rem 0 0;
        padding: 0.03rem 0.23rem 0;

        .expire-remind {
          margin-top: 0.09rem;
          font-weight: 400;
          color: #242729;

          .text-small {
            font-size: 0.14rem;
          }

          .text-big {
            // padding: 0 0.05rem;
            font-size: 0.18rem;
          }
        }

        .open-btn {
          position: relative;
          margin-top: 0.21rem;
          width: 100%;
          height: 0.52rem;
          box-shadow: 0 0.01rem 0.08rem 0 rgba(250, 87, 13, 0.4);
          background: linear-gradient(90deg, #fa8621 0%, #fa3a00 100%);
          border-radius: 0.12rem;
          text-align: center;
          line-height: 0.52rem;
          color: #fff;
          font-weight: 500;
          font-size: 0.18rem;

          .symbol {
            font-size: 0.14rem;
          }

          .lottie {
            position: absolute;
            z-index: 229;
            top: 0;
            left: 0;
            width: 3.55rem;
            height: 0.8rem;
          }

          .part {
            position: absolute;
            z-index: 2;
          }

          .toast {
            right: 0.75rem;
            top: -0.2rem;
            height: 0.33rem;
            border-radius: 0.12rem;
            // background: linear-gradient(172deg, #ffd77a 0%, #ff8b3d 100%);
            background-image: url(https://m.hellobike.com/resource/helloyun/08345/jXF9OEVxCp.png);
            background-size: 100% 100%;
            font-size: 0.12rem;
            font-family: PingFangSC-Medium, PingFang SC, sans-serif;
            font-weight: 400;
            color: #793d21;
            line-height: 0.12rem;
            padding: 0.06rem 0.06rem 0.09rem 0.06rem;
            display: flex;
            justify-content: center;

            img {
              width: 0.17rem;
              height: 0.2rem;
            }
            // transform: scale(0.5);
            // transform-origin: center center;

            // &::after {
            //   content: '';
            //   display: block;
            //   position: absolute;
            //   bottom: -0.08rem;
            //   border-left: transparent 0.1rem solid;
            //   border-right: transparent 0.1rem solid;
            //   border-top: #ff8b3d 0.1rem solid;
            // }
          }

          .toast-short {
            right: 50%;
            transform: translateX(50%);
            top: -0.2rem;
            // height: 0.33rem;
            border-radius: 0.12rem;
            background-image: url(https://m.hellobike.com/resource/helloyun/08345/7QS2QQgNqA.png);
            background-size: 100% 100%;
            font-size: 0.12rem;
            font-family: PingFangSC-Medium, PingFang SC, sans-serif;
            font-weight: 400;
            color: #793d21;
            line-height: 0.12rem;
            padding: 0.06rem 0.08rem 0.09rem 0.08rem;
            display: flex;
            justify-content: center;

            img {
              width: 0.17rem;
              height: 0.2rem;
            }

            .bestChoose {
              height: 0.2rem;
              line-height: 0.2rem;
              width: 0.65rem;
            }
          }
        }
      }

      .renewal-rules {
        margin-top: 0.15rem;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-size: 0.12rem;
        font-weight: 400;
        color: #879099;
        text-align: center;

        // .normal{

        // }

        .canClick {
          color: #1993ff;
        }
      }
    }
  }

  .shadow {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: #000;
    opacity: 0.7;
    z-index: 220;
  }
}
</style>
